import { RadioProps } from "@bluframe/blublocks"
import {
  Review,
  ReviewsServiceName
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { ChangeEvent } from "react"

import ReviewsCard from "./ReviewsCard"

export interface Props {
  actions: React.ReactNode
  avatar: string
  display: Review[]
  flagLoading: boolean
  isShowFlagButton: boolean
  onSelect: RadioProps["onChange"]
  onToggleFlagged: (id: string, isFlagged: boolean) => () => void
  selected: string
  serviceName: ReviewsServiceName
  subheader: string
  title: string
}

export interface ComponentProps extends Props {}

export default ReviewsCard
